import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Dropdown } from '../../../../components/Dropdown';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { Loader } from '../../../../components/Loader';
import { BTW_COUNTRIES, CREATE_REQUIRED_FIELDS_TYPE_COMPANY, CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL } from '../../constants';
import { initiateNewCompnayValue, setNewCompanyValue } from '../../actions';
import { selectCountries, selectHomeCompany, selectNewCompany } from '../../selectors';
import { ModalControls } from '../../../../components/Modal';
import { Checkbox } from '../../../../components/Checkbox';
import Select from 'react-select';
import { SearchCompanyAndUser } from '../../../Users/components/SearchCompanyAndUser';
import { parseUser } from '../../../Users/helpers';
import { normalizeSearchString } from '../../../../utils/normalizeSearchString';
import { fetchUser, fetchUsersList } from '../../../Users/actions';
import { selectUsers } from '../../../Users/selectors';
import { Plus } from '../../../../components/Icon';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { Left } from '../../../../components/Icon';
import { DecoratorLabel } from '../../../../components/Input';
import { List, Row, Cell } from '../../../../components/List';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_USER } from '../../../Users/constants';
import { getPropByName } from '../../../../utils/props';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { CancelNotificationModal } from '../../components/OnCancelNotificationModal';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../translate-countries';

const Container = styled.div`
  width: 94%;
  height: 100vh;
  position: fixed;
  left: 12px;
  background-color: #fff;
  z-index: 100;
  overflow: auto;

  .field-block {
    margin-bottom: 8px;
    white-space: nowrap;
    .label {
      width: 60%;
    }
    .user-selection-label {
      width: 40%;
    }
  }

  .select-user {
    margin-bottom: 8px;
  }

  .radio-label {
    margin: 0 10px;
    font-size: 14px;
  }

  .rounded {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }

  .search-select {
    min-width: 300px;
    max-width: 300px;
  }

  .user-selection {
    min-width: 250px;
    max-width: 250px;
  }
  .icon-button {
    margin: 0 10px;
  }

  .row-inputs-block {
    .col-1 {
      flex-basis: 20%;
    }
    .col-2 {
      flex-basis: 75%;
    }
  }
  .dropdown-BTW {
    > .Dropdown-root {
      min-width: 50px;
      max-width: 50px;

      > .Dropdown-menu {
        min-width: 130px;
      }
    }
  }

  .modal-top {
    z-index: 20;
    position: fixed;
    left: ${props => (props.innerWidth <= 768 ? '0px' : '')};
    // top: 0px;
    width: 100%;
    height: 90px;
    padding: 15px;
    font-weight: 600;

    background-color: ${COLOR_PRIMARY_1};
    color: #fff;
  }
  .modal-body {
    overflow: auto;
    max-height: ${props => (props.innerHeight <= 500 ? '55vh' : '66vh')};
    position: relative;
    top: 80px;
    padding: 12px;
    padding-bottom: 25%;
    background-color: #fff;
  }

  .mobile-btn-block {
    position: fixed;
    left: 0;
    bottom: 0;
    margin: 0;
    width: 100%;
    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  string: null,
  result: null,
  isCancelWithoutSave: null,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyQuickCreatorMobileModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.setValue('company', 'company_type');
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.values?.contact && prevProps.values?.contact != this.props.values?.contact) {
      const isAddedUser = this.state.result?.find(u => u.id == this.props.values?.contact);
      if (!isAddedUser) {
        this.props.fetchNewUser(this.props.values?.contact, result => this.setState({ result: [parseUser(result)] }));
      }
    }
  }

  get filterCompanyId() {
    return this.props.filter?.companyId;
  }

  get locale() {
    return this.props.locale;
  }

  get btwNumberInputValue() {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.values?.BTW_number?.includes(o.value));
    if (isWithCode) {
      return this.props.values?.BTW_number?.substring(2) || '';
    }
    return this.props.values?.BTW_number;
  }

  get requiredFields() {
    if (env.clientId !== AppClientId.AUTOWIENTJES) return [];
    const types =
      this.props.values.company_type === 'company'
        ? CREATE_REQUIRED_FIELDS_TYPE_COMPANY
        : CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL;

    return types.filter(type => !this.props.values[type]);
  }

  isNoValid(property) {
    return this.requiredFields.includes(property);
  }

  onBtwNumberChange(evt, property) {
    {
      let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
      const isWithCode = options.find(o => this.props.values[property]?.includes(o.value));

      if (isWithCode?.value) {
        this.props.setValue(`${isWithCode?.value}${evt.target.value}`, property);
        return;
      }

      this.props.setValue(evt.target.value, property);
    }
  }

  onStringChange(evt) {
    let string = evt.target?.value;
    evt && this.setState({ string });
  }

  onSearch() {
    this.search();
  }

  search() {
    const search = this.state.string?.toLowerCase();
    this.props.fetchUsers(0, undefined, search, this.filterCompanyId, result =>
      this.setState({
        result: result.items?.map(parseUser).filter(user => user.id !== this.props.user?.id),
      }),
    );
  }

  radioButtons(property) {
    return (
      <HBox left>
        <Checkbox
          onChange={pair => {
            this.props.setValue('individual', 'company_type');
            // this.props.setValue('', 'BTW_number');
            this.props.setValue('', 'contact');
            this.props.setValue('', 'company_email');
          }}
          checked={this.props.values?.company_type == 'individual'}
          className="rounded"
          rounded
        >
          <strong className="radio-label">{this.lbl('company.property.company_type.individual')}</strong>
        </Checkbox>

        <Checkbox
          onChange={pair => {
            this.props.setValue('company', 'company_type');
            this.props.setValue('', 'surname');
            this.props.setValue('', 'country_code');
            this.props.setValue('', 'phone_number');
            this.props.setValue('', 'email');
          }}
          className="rounded"
          checked={this.props.values?.company_type == 'company'}
          rounded
        >
          <strong className="radio-label">{this.lbl('company.property.company_type.company')}</strong>
        </Checkbox>
      </HBox>
    );
  }

  btwDropdown(property) {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => this.props.values[property]?.includes(o.value));

    return (
      <div className={'dropdown-BTW'}>
        <Dropdown
          options={options}
          value={value?.value ? value?.value + ' ' : ''}
          onChange={pair => {
            if (value?.value) {
              this.props.setValue(`${pair.value}${this.props.values?.BTW_number?.substring(2) || ''}`, 'BTW_number');
              return;
            }
            return this.props.setValue(`${pair.value}${this.props.values?.BTW_number || ''}`, 'BTW_number');
          }}
        />
      </div>
    );
  }

  searchSelect() {
    const options = this.props.countries?.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }));
    const value = options.find(o => o.value == this.props.values?.countryId);
    return (
      <Select
        placeholder={this.lblStr(`company.property.countryId`)}
        options={options}
        value={value}
        onChange={evt => this.props.setValue(evt.value, 'countryId')}
        className={'search-select'}
      />
    );
  }

  userSelection() {
    if (this.props.workUser) return <Loader small />;
    const options = this.state.result?.map(user => ({
      value: user.id,
      label: `${user.name || ''} ${user.surname || ''} ${user.email_address || ''}`,
    }));
    const value = options?.find(o => o.value == this.props.values?.contact);
    return (
      <VBox>
        <FormField>
          <Input
            name="string"
            onChange={this.onStringChange.bind(this)}
            value={value?.label}
            rightDecoration={
              <DecoratorLabel>
                {' '}
                <Button small onClick={this.search.bind(this)}>
                  {this.lbl('search ')}
                </Button>
              </DecoratorLabel>
            }
          />
        </FormField>
        {this.renderResult()}
      </VBox>
    );
  }

  renderResult() {
    if (!this.state.result) return '';
    return (
      <div className="results">
        <List>
          {this.state.result?.map(user => (
            <Row
              key={user.id}
              onClick={() => {
                this.props.setValue(user?.id, 'contact');
                this.setState({ result: null });
              }}
            >
              <Cell>
                {user?.name}
                &nbsp;
                {user?.surname}
                &nbsp;
                {user.email_address}
              </Cell>
            </Row>
          ))}
        </List>
      </div>
    );
  }

  renderDuplicateEmailNotification() {
    const { duplicateUser } = this.props;

    if (!duplicateUser?.length) return;

    const email = duplicateUser[0]?.email_address;
    const name = getPropByName(duplicateUser[0], 'name');
    const surnaname = getPropByName(duplicateUser[0], 'surname');

    return (
      <HBox center>
        <VBox center style={{ width: '80%' }}>
          <strong>{`Email ${email} in use by ${name} ${surnaname}. Do you want to add this user for this company?`}</strong>
          <HBox center vCenter>
            <Button
              disabled={this.applyDisabled()}
              small
              primary
              onClick={() => this.props.onSave({ id: duplicateUser[0]?.id })}
            >
              {this.lbl('yes')}
            </Button>
            <Button disabled={this.applyDisabled()} small warning onClick={() => this.props.onSave('no')}>
              {this.lbl('no')}
            </Button>
          </HBox>
        </VBox>
      </HBox>
    );
  }

  applyDisabled() {
    return this.props.workCreate || this.props.workUser || !this.props.values?.accountManagerId;
  }

  isWaiting() {
    return this.props.workCreate || this.props.workUser;
  }

  onApprove(answer, callback = () => {}) {
    return this.setState({ isCancelWithoutSave: answer }, () => callback());
  }

  cancel() {
    if (env.clientId !== AppClientId.AUTOWIENTJES || this.state.isCancelWithoutSave == 'yes') {
      return this.reset();
    }
    if (!this.state.isCancelWithoutSave) {
      return this.setState({ isShowCancelNotification: true });
    }

    return this.setState({ isShowCancelNotification: false, isCancelWithoutSave: null });
  }

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.onCancel();
  }

  render() {
    return (
      <Container innerHeight={window.innerHeight} innerWidth={window.innerWidth}>
        {this.state.isShowCancelNotification && (
          <CancelNotificationModal
            onYes={() => this.onApprove('yes', this.cancel.bind(this))}
            onNo={() => this.onApprove('no', this.cancel.bind(this))}
          />
        )}
        <HBox vCenter left className="modal-top" onClick={() => this.cancel()}>
          <Left /> {this.lbl('company.create.modal.title')}
        </HBox>
        <VBox className="modal-body">
          {this.props.fields?.map(property => {
            if (property == 'company_type') {
              return (
                <HBox left vCenter className={'field-block'}>
                  <FormField>{this.radioButtons(property)}</FormField>
                </HBox>
              );
            }

            if (property == 'country_code') return;

            if (property == 'BTW_number') {
              return (
                this.props.values?.company_type == 'company' && (
                  <HBox vCenter className={'field-block'}>
                    <HBox style={{ minWidth: '300px' }}>
                      <div style={{ width: '100px' }}>{this.btwDropdown(property)}</div>
                      <FormField>
                        <Input
                          placeholder={this.lblStr('company.property.BTW_number')}
                          value={this.btwNumberInputValue}
                          onChange={evt => this.onBtwNumberChange(evt, property)}
                          style={{ maxWidth: '250px' }}
                        />
                      </FormField>
                    </HBox>
                  </HBox>
                )
              );
            }

            if (property == 'countryId') {
              return (
                <HBox vCenter className={'field-block'}>
                  <FormField>
                    <>
                      {this.searchSelect()}
                      {this.isNoValid(property) && <RequireMark>*</RequireMark>}
                    </>
                  </FormField>
                </HBox>
              );
            }

            if (property == 'accountManagerId') {
              return (
                <HBox vCenter className="field-block select-user">
                  {!this.props.values?.accountManagerId && (
                    <p className={'label'}>{this.lbl(`company.property.${property}`)}</p>
                  )}
                  <HBox left>
                    <SearchCompanyAndUser
                      homeCompanyId={this.props.homeCompanyId}
                      key={`${property}-${this.props.values[property]}`}
                      type={property}
                      value={this.props.values[property]}
                      onSelect={value => this.props.setValue(value?.id, property)}
                    />
                    {!this.props.values?.accountManagerId && <RequireMark>*</RequireMark>}
                  </HBox>
                </HBox>
              );
            }

            if (property == 'contact') {
              return (
                this.props.values?.company_type == 'company' && (
                  <HBox vCenter className={'field-block'}>
                    <HBox left style={{ alignItems: 'baseline' }}>
                      <div style={{ width: '60%' }}>
                        <FormField>{this.userSelection()} </FormField>
                      </div>
                      <div className="icon-button">
                        <Button small onClick={() => this.props.onShowUserModal()}>
                          {this.lbl('company.create.modal.new_contact')}
                        </Button>
                      </div>
                    </HBox>
                  </HBox>
                )
              );
            }

            if (['name', 'addressLine1', 'postcode', 'city'].includes(property)) {
              return (
                <HBox vCenter className={'field-block'}>
                  <FormField>
                    <>
                      <Input
                        placeholder={this.lblStr(`company.property.${property}`)}
                        value={this.props.values[property]}
                        onChange={evt => this.props.setValue(evt.target.value, property)}
                        style={{ minWidth: '300px' }}
                      />
                      {this.isNoValid(property) && <RequireMark>*</RequireMark>}
                    </>
                  </FormField>
                </HBox>
              );
            }

            if (property == 'surname') {
              return (
                this.props.values?.company_type == 'individual' && (
                  <HBox vCenter className={'field-block'}>
                    <FormField>
                      <>
                        <Input
                          placeholder={this.lblStr(`company.property.${property}`)}
                          value={this.props.values[property]}
                          onChange={evt => this.props.setValue(evt.target.value, property)}
                          style={{ minWidth: '300px' }}
                        />
                        {this.isNoValid(property) && <RequireMark>*</RequireMark>}
                      </>
                    </FormField>
                  </HBox>
                )
              );
            }
            if (property == 'email') {
              return (
                this.props.values?.company_type == 'individual' && (
                  <HBox vCenter className={'field-block'}>
                    <FormField>
                      <Input
                        placeholder={this.lblStr(`company.property.${property}`)}
                        value={this.props.values[property]}
                        onChange={evt => this.props.setValue(evt.target.value, property)}
                        style={{ minWidth: '300px' }}
                      />
                    </FormField>
                  </HBox>
                )
              );
            }
            if (property == 'company_email') {
              return (
                this.props.values?.company_type == 'company' && (
                  <HBox vCenter className={'field-block'}>
                    <FormField>
                      <Input
                        placeholder={this.lblStr(`company.property.${property}`)}
                        value={this.props.values[property]}
                        onChange={evt => this.props.setValue(evt.target.value, property)}
                        style={{ minWidth: '300px' }}
                      />
                    </FormField>
                  </HBox>
                )
              );
            }
            if (property == 'phone_number') {
              return (
                this.props.values?.company_type == 'individual' && (
                  <HBox vCenter className={'field-block'}>
                    <HBox left className="row-inputs-block">
                      <FormField className="col-1">
                        <Input
                          value={this.props.values?.country_code}
                          onChange={evt => this.props.setValue(evt.target.value, 'country_code')}
                          style={{ minWidth: '50px' }}
                        />
                      </FormField>
                      <FormField className="col-2">
                        <Input
                          placeholder={this.lblStr(`company.property.${property}`)}
                          value={this.props.values[property]}
                          onChange={evt => this.props.setValue(evt.target.value, property)}
                          style={{}}
                        />
                        {this.isNoValid(property) && <RequireMark>*</RequireMark>}
                      </FormField>
                    </HBox>
                  </HBox>
                )
              );
            }
            return (
              <HBox vCenter className={'field-block'}>
                <FormField>
                  <Input
                    placeholder={this.lblStr(`company.property.${property}`)}
                    value={this.props.values[property]}
                    onChange={evt => this.props.setValue(evt.target.value, property)}
                    style={{ minWidth: '300px' }}
                  />
                </FormField>
              </HBox>
            );
          })}

          {this.isWaiting() ? (
            <HBox center>
              <strong>{this.lbl('please_wait')}</strong>
            </HBox>
          ) : (
            ''
          )}
          {this.renderDuplicateEmailNotification()}
          <ModalControls className="mobile-btn-block">
            <Button disabled={this.props.workCreate} select className="modal-footer-button" onClick={() => this.cancel()}>
              {this.lbl(`cancel`)}
            </Button>
            <Button
              disabled={this.applyDisabled() || this.props.duplicateUser?.length}
              select={this.isWaiting() || this.props.duplicateUser?.length}
              className="modal-footer-button"
              onClick={this.save.bind(this)}
            >
              {this.lbl(`confirm`)}
            </Button>
          </ModalControls>
        </VBox>
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewCompany(),
    countries: selectCountries(),
    users: selectUsers(),
    homeCompanyId: selectHomeCompany(),
    workUser: selectWork(REQUEST_USER),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null, type) {
      name = name ?? type;
      dispatch(setNewCompanyValue(name, value));
    },
    fetchUsers: (offset, limit, string, companyId, callback) => {
      dispatch(fetchUsersList(offset, limit, string, companyId, callback));
    },
    initiateValue(type) {
      dispatch(initiateNewCompnayValue(type));
    },
    fetchNewUser(userId, callback) {
      dispatch(fetchUser(userId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyQuickCreatorMobileModal = compose(
  withConnect,
  withRouter,
  injectIntl,
)(CompanyQuickCreatorMobileModalComp);
